import { Flex } from "@mantine/core";
import { ErrorBoundary } from "react-error-boundary";

import { UI_ORCHESTRATION_COMPONENT } from "@/expert-hub/data/expertHubErrorMetric";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { trackedBoundaryProps } from "@/shared-utils";
import { PlatformTimeline } from "@/timeline";

export function AssistTab() {
    const logger = useLogger({ module: "AssistTab" });

    return (
        <Flex pos="absolute" inset={0} direction="column">
            <ErrorBoundary {...trackedBoundaryProps(logger, UI_ORCHESTRATION_COMPONENT)}>
                <PlatformTimeline />
            </ErrorBoundary>
        </Flex>
    );
}
